// extracted by mini-css-extract-plugin
export default {"statusWrapper":"CustomStatus_statusWrapper__gkGiF"};